import { trapFocus } from './focus-trap';

const Search = {
    init() {
        let headerSearchActive = false;

        $('.cta-search-label').on('click', function () {
            $('#mobile-search-wrapper').addClass('open');
            $('.autocomplete-input-v2').focus();
            $('body').addClass('overflow-hidden md:overflow-auto');
            $('.header').addClass('fixed-header');
            $('.link-all-communities').attr(
                'href',
                $('#home_browse_cta_link_url').val()
            );
            $('.link-all-communities-span').html(
                $('#home_browse_cta_link_title').val()
            );
        });
        $('.mobile-ham-search').on('click', function () {
            $('#mobile-quick-search-wrapper').addClass('open');
            $('body').addClass('overflow-hidden lg:overflow-auto');
            $('.header').addClass('fixed-header-ham');
        });

        $('.cta-close').on('click', function () {
            $(
                '#mobile-search-wrapper, #mobile-quick-search-wrapper'
            ).removeClass('open');
            $('body').removeClass(
                'overflow-hidden md:overflow-auto lg:overflow-auto'
            );
            $('.header').removeClass('fixed-header fixed-header-ham');
        });

        // Show the first tab and hide the rest
        $('.results-tab-nav a:first-child').addClass('active');
        $('.results-tab-content').addClass('tab-hidden');
        $('.results-tab-content:first').removeClass('tab-hidden');

        // Click function
        $('.results-tab-nav a').on('click', function () {
            $('.results-tab-nav a').removeClass('active');
            $(this).addClass('active');
            $('.results-tab-content').addClass('tab-hidden');

            var activeTab = $(this).attr('href');
            $(activeTab).removeClass('tab-hidden');
            return false;
        });
        $('.advanced-filter-facet').on('click keydown', function (event) {
            // $(this).toggleClass('is-active');
            if (
                event.type === 'click' ||
                (event.type === 'keydown' && event.key === 'Enter')
            ) {
                $(this).toggleClass('is-active');
            }
        });
        $('.cta-more-filters').on('click', function () {
            $('#modal-more-filters').show();
            $('body').addClass('hide-overflow fixed');
            $('.search-filter').attr('open', false);
            trapFocus(document.getElementById('modal-more-filters'));
        });
        $('.more-filters-close-btn').on('click', function () {
            $('#modal-more-filters').hide();
            $('body').removeClass('hide-overflow fixed');
            $('.search-filter').attr('open', false);
        });
        $('.bed-filter-check').on('click keydown', function (event) {
            // $('.bed-filter-check').removeClass('is-active');
            // $(this).addClass('is-active');
            if (
                event.type === 'click' ||
                (event.type === 'keydown' && event.key === 'Enter')
            ) {
                event.preventDefault(); // Prevent default for the Enter key
                $('.bed-filter-check').removeClass('is-active');
                $(this).addClass('is-active');
            }
        });
        $('.header-search-icon').on('click', function () {
            $(this).parent().hide();
            headerSearchActive = true;
            $('.header-searchbar').show(500);
            isFocusInside = true;
            setTimeout(() => {
                $input.focus();
            }, 500);
        });
        $('.header-searchbar-cta-close').on('click', function () {
            $('.header-searchbar').hide(500, function () {
                $('.header-searchbar').prev().show();
                $('.autocomplete-input-v2').val('');
                headerSearchActive = false;
                $('.header-search-icon');
            });
        });

        $(window).resize(function (e) {
            if (headerSearchActive) {
                if ($(window).width() < 1024) {
                    $('.header-searchbar').hide(500, function () {
                        $('.header-searchbar').prev().show();
                    });
                } else {
                    $('.header-searchbar').show();
                    $('.header-search-icon').parent().hide();
                }
            }
        });

        const $searchbar = $('.header-searchbar');
        const $input = $searchbar.find('.autocomplete-input-v2');
        const $searchBtn = $searchbar.find('.header-searchbar-cta-search');

        let isFocusInside = false;

        // Focus detection
        $searchbar.on('focusin', function () {
            isFocusInside = true;
        });

        $searchbar.on('focusout', function (event) {
            // Check if focus is leaving the searchbar

            if (!$.contains($searchbar[0], event.relatedTarget)) {
                isFocusInside = false;
                // $dropdown.removeClass('is-active'); // Hide dropdown

                setTimeout(() => {
                    $('.header-searchbar').hide(500, function () {
                        $('.header-searchbar').prev().show();
                        $('.autocomplete-input-v2').val('');
                        headerSearchActive = false;
                        $('.header-search-icon').focus();
                    });
                }, 200);
            }
        });

        // Detect clicks outside the searchbar
        $(document).on('click', function (event) {
            if (!$(event.target).closest($searchbar).length) {
                if (isFocusInside) {
                    isFocusInside = false;
                }
            }
        });
    },
};
export default Search;
